import { PermissionGroup } from '../../domain/models/permission-group.model';
import { PermissionGroupApiDTO } from '../dto/permission-group.api.dto';

export class PermissionGroupMapper {
  static toDomain(dto: PermissionGroupApiDTO): PermissionGroup {
    return {
      id: dto.id,
      organizationId: dto.organizationId,
      name: dto.name,
      color: dto.color,
      permissionIds: dto.permissionIds,
      createdAt: dto.createdAt,
      createdBy: dto.createdBy,
      updatedAt: dto.updatedAt,
      updatedBy: dto.updatedBy,
      removedAt: dto.removedAt,
      removedBy: dto.removedBy,
    };
  }

  static toDomainArray(dtos: PermissionGroupApiDTO[]): PermissionGroup[] {
    return dtos.map(dto => this.toDomain(dto));
  }
}